import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/layout/Layout';

import Landing from './pages/Landing';
import About from './pages/About';
import Solutions from './pages/Solutions';
import SolutionDetail from './pages/SolutionDetail';
import Advisory from './pages/Advisory';
import Insights from './pages/Insights';
import ArticleDetail from './pages/ArticleDetail';
import Contact from './pages/Contact';
import Careers from './pages/Careers';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import Withdrawals from './pages/Withdrawals';
import PendingConfirmations from './pages/PendingConfirmations';
import CreatePlan from './pages/CreatePlan';
import Plans from './pages/Plans';
import UserWallets from './pages/UserWallets';
import Profile from './pages/Profile';
import UserManagement from './pages/UserManagement';
import CreateInvestment from './pages/CreateInvestment';
import Transactions from './pages/Transactions';
import SystemWallets from './pages/SystemWallets';
import KYCManagement from './pages/KYCManagement';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Terms from './pages/Terms';
import './styles/App.css';

import PublicLayout from './components/layout/PublicLayout';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/solutions/:id" element={<SolutionDetail />} />
            <Route path="/advisory" element={<Advisory />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:id" element={<ArticleDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
          </Route>
          
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          
          {/* Protected Area Wrapped in Layout */}
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/withdrawals" element={<Withdrawals />} />
                    <Route path="/pending-confirmations" element={<PendingConfirmations />} />
                    <Route path="/create-plan" element={<CreatePlan />} />
                    <Route path="/plans" element={<Plans />} />
                    <Route path="/user-wallets" element={<UserWallets />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/user-management" element={<UserManagement />} />
                    <Route path="/create-investment" element={<CreateInvestment />} />
                    <Route path="/transactions" element={<Transactions />} />
                    <Route path="/system-wallets" element={<SystemWallets />} />
                    <Route path="/kyc-management" element={<KYCManagement />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
